import type { ISession } from '../interface/session';
import { ISessionData } from '../private/db';

function flatten(session: ISession): ISessionData {
    return {
        name: session.name,
        userState: session.state.flatten() ?? '',
        auth: session.auth.serialize() ?? '',
    };
}

const module = {
    flatten,
};

export default module;
